const filterByUniqueKey = (array, key, conditionalFn = () => true) => {
  const uniqueMap = {};
  return array.filter((n) => {
    const ignore = !conditionalFn(n);
    if (!n[key] || ignore) {
      return true;
    }
    if (uniqueMap[n[key]]) {
      return false;
    }
    return (uniqueMap[n[key]] = true);
  });
};

export default filterByUniqueKey;
